import client from 'api/client';
import { AxiosResponse, AxiosRequestConfig } from 'axios';

export interface ForgotPasswordPayload {
    email: string;
}

export interface ForgotPasswordResponse {
    msg: string;
}

/**
 * Request a password reset link.
 *
 * The backend always responds 200 with a generic message regardless of
 * whether the email belongs to an account (anti-enumeration), and emails a
 * one-time, expiring reset link. Rate limited to 5 requests/hour per IP
 * (returns 429 on exceed).
 */
export function post(
    payload: ForgotPasswordPayload,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<ForgotPasswordResponse>> {
    return client.post<ForgotPasswordResponse>(`/forgot-password`, payload, customConfig);
}

/**
 * @deprecated Use {@link post} instead. The legacy `GET /forgot_password/<email>`
 * endpoint still exists but now also just emails a reset link rather than a
 * temporary password.
 */
export function get(email: string, customConfig?: AxiosRequestConfig) {
    const url = `forgot-password/${email}`;
    return client.get<{ url: string }>(url, customConfig);
}
